import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, ControlContainer, FormGroup, FormGroupDirective } from '@angular/forms';
import { DatalayerService, FormFieldValidationEvent } from '@woolworthsnz/styleguide';
import { Observable, Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'form-input-error',
	template: ` <ng-content></ng-content> `,
	styleUrls: ['./input-error.component.scss'],
	standalone: true,
})
export class InputErrorComponent implements OnInit, OnDestroy {
	@Input() control: string;

	controlValue$: Observable<any>;
	controlStatus$: Observable<any>;
	formControl: AbstractControl | null;
	private destroyed$: Subject<boolean> = new Subject();

	constructor(private fg: ControlContainer, private datalayerService: DatalayerService) {}

	ngOnInit(): void {
		if (this.form) {
			this.formControl = this.form.get(this.control);

			if (this.formControl instanceof AbstractControl) {
				this.controlValue$ = this.formControl.valueChanges;
				this.controlStatus$ = this.formControl.statusChanges;
				this.controlValue$.pipe(takeUntil(this.destroyed$), debounceTime(1000)).subscribe(this.pushToDataLayer);
			}
		}
	}

	ngOnDestroy(): void {
		this.destroyed$.next(true);
		this.destroyed$.complete();
	}

	get form(): FormGroup<any> | null {
		return this.fg.formDirective ? (this.fg.formDirective as FormGroupDirective).form : null;
	}

	getErrorType(error: string): boolean {
		if (!this.formControl || !this.formControl.errors) {
			return false;
		}

		if (Object.keys(this.formControl.errors).indexOf(error) > -1 || error === '*') {
			return true;
		}

		return false;
	}

	pushToDataLayer = (): void => {
		const hasError = this.formControl && this.formControl.errors;
		const data: FormFieldValidationEvent = {
			event: 'formFieldValidationEvent',
			fieldName: this.control,
			filedValue: this.formControl?.value,
			fieldValidated: hasError ? 'Fail' : 'Pass',
		};
		this.datalayerService.pushToDatalayer(data);
	};
}
